export default __webpack_public_path__ + "static/media/durvis-5-min.d85832a6.jpg";